import Vue from 'vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import {

} from '@fortawesome/free-regular-svg-icons'

import {
  faSignOutAlt, faLock, faCog, faHome, faChartBar, faBell, faUser, faEnvelope,
} from '@fortawesome/free-solid-svg-icons'

library.add(
  faUser, faSignOutAlt, faLock, faCog, faHome, faChartBar, faBell, faEnvelope
)

Vue.component('fa', FontAwesomeIcon)


// WEBPACK FOOTER //
// ./src/plugins/fontawesome.js